module.exports = __webpack_public_path__ + "img/chapter-2-thumb.f0913082.jpg";